import {
	CalendarEvent,
	Department,
	Model,
	SafetyNearMissReport,
	Salesman,
	YardDriver,
	YardSchedule
} from ".";

export default class User extends Model {
	get singularNoun() {
		return "user";
	}

	get mutations() {
		return {
			calendarEvents: CalendarEvent,
			departments: Department,
			driver: YardDriver,
			nearMissReports: SafetyNearMissReport,
			salesman: Salesman,
			schedules: YardSchedule,
			supervisedNearMissReports: SafetyNearMissReport
		};
	}

	get departmentNames() {
		if ( this.departments ) {
			return this.departments.map( department => department.name ).join( ", " );
		}
	}

	get shortName() {
		return `${this.firstName} ${this.lastName.charAt( 0 )}`;
	}
}
